<template>
  <div>
    <!-- <label for="example-input">Sätt datum</label> -->
    <b-input-group class="md-7">
      <b-input-group-prepend v-if="stepper&&!readonly">
        <b-button size="sm" @click="datestep(-1)" title="Föregående dag" :disabled="disabled">
        &lsaquo;
          <!-- <b-icon-caret-left></b-icon-caret-left> -->
        </b-button>
        <b-button size="sm" @click="datestep(1)" title="Nästa dag" :disabled="disabled">
          <!-- <b-icon-caret-right></b-icon-caret-right> -->
          &rsaquo;
        </b-button>
      </b-input-group-prepend>
      <b-form-input v-model="dt" type="text" placeholder="ÅÅÅÅ-MM-DD" autocomplete="off" size="sm" @context="onContext"
        @change="onchange" @input="oninput" :disabled="disabled" :readonly="readonly"></b-form-input>
      <b-input-group-append v-if="!readonly">
        <b-form-datepicker size="sm" v-model="dt" button-only right locale="sv-SE" variant="secondary"
          @context="onContext" @change="onchange" @input="oninput" :disabled="disabled"></b-form-datepicker>
      </b-input-group-append>
    </b-input-group>    
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "datepicker",
  props: { value: String, stepper: { type: Boolean, default:false}, disabled: {type: Boolean, default: false}, readonly: {type: Boolean, default: false} },
  data() {
    return {
      dt: "",
      formatted: "",
      selected: "",
    };
  },
  created() {
    if (this.value) {
      this.dt = moment(String(this.value)).format("YYYY-MM-DD");
    } else {
      this.dt = this.value;
    }
  },
  watch: {
    value: function () {
      if (this.value) {
        var t = moment(String(this.value));
        if (t.isValid())
          this.dt = moment(String(this.value)).format("YYYY-MM-DD");
      } else {
        this.dt = this.value;
      }
    },
  },
  methods: {
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD;
    },
    onchange() {
      if (this.isValidDate(this.dt))
        this.$emit("change", this.dt);
    },
    oninput() {
      if (this.isValidDate(this.dt))
        this.$emit("input", this.dt);
    },
    isValidDate(d) {
      if (!d)
        return false;

      var date_regex = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/;
      if (!date_regex.test(String(d)))
        return false;

      var t = moment(String(d), 'YYYY-MM-DD', true);
      return (t.isValid());
    },
     datestep(s) {
      if (this.dt) {
        this.dt = moment(String(this.dt)).add('days', s).format("YYYY-MM-DD");
        this.oninput();
      }
    },
  },
};
</script>
<style scoped>
.badformat {
  background-color: lightcoral;
}
</style>